import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=82a4faf6&scoped=true&"
import script from "./Inventario.vue?vue&type=script&lang=js&"
export * from "./Inventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4faf6",
  null
  
)

export default component.exports